import { useEffect } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { Link } from 'react-router-dom';

const Casper = () => {
  useEffect(() => {
    // Set document title
    document.title = "We Buy Valves Casper | Industrial Equipment Buyers Casper Wyoming";
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'We Buy Valves Casper Wyoming - Top cash buyer for surplus industrial valves, control valves, instrumentation equipment in Central Wyoming oil & gas and refining operations. Same-day offers, immediate payment.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'We Buy Valves Casper Wyoming - Top cash buyer for surplus industrial valves, control valves, instrumentation equipment in Central Wyoming oil & gas and refining operations. Same-day offers, immediate payment.';
      document.head.appendChild(meta);
    }

    // Set meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'we buy valves casper, casper valve buyers, wyoming oil gas equipment buyers, industrial equipment buyers casper, surplus valve buyers wyoming');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'keywords';
      meta.content = 'we buy valves casper, casper valve buyers, wyoming oil gas equipment buyers, industrial equipment buyers casper, surplus valve buyers wyoming';
      document.head.appendChild(meta);
    }

    // Set canonical URL
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', 'https://valvesalessupply.com/casper');
    } else {
      const link = document.createElement('link');
      link.rel = 'canonical';
      link.href = 'https://valvesalessupply.com/casper';
      document.head.appendChild(link);
    }

    // Set Open Graph tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', 'Casper Valve Buyers | We Buy Industrial Equipment Casper Wyoming');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:title');
      meta.content = 'Casper Valve Buyers | We Buy Industrial Equipment Casper Wyoming';
      document.head.appendChild(meta);
    }

    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', 'We Buy Valves Casper Wyoming - Leading valve buyers serving Central Wyoming oil & gas, refining operations, and energy infrastructure.');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:description');
      meta.content = 'We Buy Valves Casper Wyoming - Leading valve buyers serving Central Wyoming oil & gas, refining operations, and energy infrastructure.';
      document.head.appendChild(meta);
    }

    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', 'https://valvesalessupply.com/casper');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:url');
      meta.content = 'https://valvesalessupply.com/casper';
      document.head.appendChild(meta);
    }

    // Set geo tags
    const geoPosition = document.querySelector('meta[name="geo.position"]');
    if (geoPosition) {
      geoPosition.setAttribute('content', '42.8500;-106.3131');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'geo.position';
      meta.content = '42.8500;-106.3131';
      document.head.appendChild(meta);
    }

    const geoRegion = document.querySelector('meta[name="geo.region"]');
    if (geoRegion) {
      geoRegion.setAttribute('content', 'US-WY');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'geo.region';
      meta.content = 'US-WY';
      document.head.appendChild(meta);
    }

    const geoPlacename = document.querySelector('meta[name="geo.placename"]');
    if (geoPlacename) {
      geoPlacename.setAttribute('content', 'Casper, Wyoming');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'geo.placename';
      meta.content = 'Casper, Wyoming';
      document.head.appendChild(meta);
    }

    // Cleanup function to remove meta tags when component unmounts
    return () => {
      const tags = ['description', 'keywords'];
      tags.forEach(name => {
        const element = document.querySelector(`meta[name="${name}"]`);
        if (element && element.content.includes('casper')) {
          element.remove();
        }
      });
      
      const ogTags = ['og:title', 'og:description', 'og:url'];
      ogTags.forEach(property => {
        const element = document.querySelector(`meta[property="${property}"]`);
        if (element && element.content.includes('casper')) {
          element.remove();
        }
      });

      const geoTags = ['geo.position', 'geo.region', 'geo.placename'];
      geoTags.forEach(name => {
        const element = document.querySelector(`meta[name="${name}"]`);
        if (element && (element.content.includes('Casper') || element.content.includes('42.8500') || element.content.includes('US-WY'))) {
          element.remove();
        }
      });

      const canonical = document.querySelector('link[rel="canonical"]');
      if (canonical && canonical.href.includes('casper')) {
        canonical.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-16 bg-gradient-to-b from-[#1B3A5F] to-[#2B4A6F]">
        <div className="max-w-7xl mx-auto px-6 text-center text-white">
          <h1 className="text-5xl font-bold mb-6">We Buy Valves Casper</h1>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Leading valve and instrumentation buyer serving Casper and Central Wyoming's 
            oil &amp; gas production, refining operations, and energy infrastructure facilities.
          </p>
        </div>
      </section>

      {/* Quick Contact Bar */}
      <section className="bg-white py-6 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex items-center">
              <i className="ri-map-pin-line text-[#1B3A5F] text-2xl mr-3"></i>
              <span className="text-gray-700 font-semibold">Serving Casper &amp; Central Wyoming</span>
            </div>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="tel:214-854-5638"
                className="bg-[#1B3A5F] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#2B4A6F] transition-all duration-300 flex items-center justify-center whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                (214) 854-5638
              </a>
              <a
                href="mailto:casper@valvesalessupply.com"
                className="border-2 border-[#1B3A5F] text-[#1B3A5F] px-6 py-3 rounded-full font-semibold hover:bg-[#1B3A5F] hover:text-white transition-all duration-300 flex items-center justify-center whitespace-nowrap"
              >
                <i className="ri-mail-line mr-2"></i>
                Email Casper Team
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Market Overview */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-[#1B3A5F] text-4xl font-bold mb-6">
                Casper Industrial Equipment Buyers
              </h2>
              <p className="text-gray-700 text-lg leading-relaxed mb-6">
                Valve Sales Supply provides comprehensive equipment purchasing services to Casper's 
                thriving energy sector, including oil refineries, natural gas processing facilities, 
                and upstream production operations throughout Central Wyoming.
              </p>
              <p className="text-gray-700 text-lg leading-relaxed mb-6">
                Our team specializes in acquiring surplus valves, instrumentation, and process control 
                equipment from refinery turnarounds, facility upgrades, and well site decommissioning 
                projects across Wyoming's major energy producing regions.
              </p>
              <div className="grid md:grid-cols-2 gap-4">
                {[
                  'Same-Day Response',
                  '24-Hour Quotes',
                  'Refinery Expertise',
                  'Fair Market Pricing',
                  'Complete Documentation',
                  'Licensed &amp; Insured'
                ].map((feature, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-[#1B3A5F] mr-3 text-xl"></i>
                    <span className="text-gray-700 font-semibold">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="rounded-3xl overflow-hidden shadow-lg">
              <img 
                src="https://public.readdy.ai/ai/img_res/73189c4aac7ffc098a1d812741d83281.jpg"
                alt="Casper Industrial Area"
                className="w-full h-96 object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Major Facilities Served */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">
              Casper Facilities We Serve
            </h2>
            <p className="text-gray-600 text-xl">
              Supporting Central Wyoming's oil &amp; gas and energy sectors
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                name: 'Sinclair Casper Refinery',
                type: 'Oil Refining',
                icon: 'ri-oil-line',
                description: '24,500 BPD refinery with full processing units'
              },
              {
                name: 'Powder River Basin Operations',
                type: 'Oil &amp; Gas Production',
                icon: 'ri-fire-line',
                description: 'Major oil and gas producing region'
              },
              {
                name: 'Gas Processing Plants',
                type: 'Natural Gas Processing',
                icon: 'ri-flask-line',
                description: 'Multiple gas processing facilities in region'
              },
              {
                name: 'Pipeline Infrastructure',
                type: 'Midstream Operations',
                icon: 'ri-route-line',
                description: 'Major pipeline systems and terminals'
              },
              {
                name: 'Well Site Operations',
                type: 'Upstream Production',
                icon: 'ri-hammer-line',
                description: 'Numerous oil and gas well sites'
              },
              {
                name: 'Industrial Manufacturing',
                type: 'Oilfield Services',
                icon: 'ri-tools-line',
                description: 'Equipment manufacturing and services'
              }
            ].map((facility, index) => (
              <div key={index} className="bg-[#F5F7FA] rounded-3xl p-6">
                <div className="w-16 h-16 bg-[#1B3A5F] rounded-2xl flex items-center justify-center mb-4">
                  <i className={`${facility.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-2">{facility.name}</h3>
                <p className="text-gray-600 font-semibold mb-2">{facility.type}</p>
                <p className="text-gray-600 text-sm">{facility.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Equipment Categories */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">
              Equipment We Purchase in Casper
            </h2>
            <p className="text-gray-600 text-xl">
              Specialized in refinery and oil &amp; gas production equipment
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                title: 'Refinery Valves',
                icon: 'ri-settings-3-line',
                items: ['Ball Valves', 'Gate Valves', 'Globe Valves', 'Check Valves']
              },
              {
                title: 'Flow Control',
                icon: 'ri-bar-chart-line',
                items: ['Flow Meters', 'Control Valves', 'Regulators', 'Actuators']
              },
              {
                title: 'Process Control',
                icon: 'ri-cpu-line',
                items: ['PLCs', 'DCS Systems', 'Controllers', 'Transmitters']
              },
              {
                title: 'Safety Equipment',
                icon: 'ri-shield-check-line',
                items: ['Relief Valves', 'Safety Systems', 'Gas Detection', 'ESD Systems']
              }
            ].map((category, index) => (
              <div key={index} className="bg-white rounded-3xl p-6">
                <div className="w-16 h-16 bg-[#1B3A5F] rounded-2xl flex items-center justify-center mb-4">
                  <i className={`${category.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-4">{category.title}</h3>
                <ul className="space-y-2">
                  {category.items.map((item, itemIndex) => (
                    <li key={itemIndex} className="flex items-center text-gray-700">
                      <i className="ri-check-line text-[#1B3A5F] mr-2"></i>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Service Advantages */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">
              Why Casper Facilities Choose Us
            </h2>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                title: 'Energy Sector Expertise',
                icon: 'ri-oil-line',
                description: 'Deep understanding of Wyoming\'s oil &amp; gas industry with specialized knowledge of refinery operations and upstream production equipment standards.'
              },
              {
                title: 'Fast Response',
                icon: 'ri-time-line',
                description: 'Same-day site visits throughout Casper and Central Wyoming with 24-hour quotes for all equipment types and project sizes.'
              },
              {
                title: 'Professional Service',
                icon: 'ri-award-line',
                description: 'Licensed, insured, and experienced team handling everything from small instrument lots to complete refinery turnaround projects.'
              }
            ].map((advantage, index) => (
              <div key={index} className="bg-[#F5F7FA] rounded-3xl p-8 text-center">
                <div className="w-20 h-20 bg-[#1B3A5F] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${advantage.icon} text-white text-3xl`}></i>
                </div>
                <h3 className="text-[#1B3A5F] text-2xl font-bold mb-4">{advantage.title}</h3>
                <p className="text-gray-600 leading-relaxed">{advantage.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Related Markets */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">
              Other Wyoming Markets We Serve
            </h2>
            <p className="text-gray-600 text-xl">
              Comprehensive coverage across Wyoming
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto mb-8">
            <Link
              to="/cheyenne"
              className="bg-white rounded-2xl p-6 hover:shadow-lg transition-all duration-300 flex items-center justify-between group"
            >
              <div>
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-1">Cheyenne</h3>
                <p className="text-gray-600">Southeast Wyoming Hub</p>
              </div>
              <i className="ri-arrow-right-line text-[#1B3A5F] text-2xl group-hover:translate-x-2 transition-transform"></i>
            </Link>
          </div>

          <div className="text-center">
            <Link
              to="/wyoming"
              className="inline-flex items-center text-[#1B3A5F] font-semibold text-lg hover:underline"
            >
              View All Wyoming Cities
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-[#1B3A5F]">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-white text-4xl font-bold mb-6">
            Get Your Casper Equipment Quote Today
          </h2>
          <p className="text-gray-200 text-xl mb-10">
            Fast, professional service for all your surplus equipment needs in Central Wyoming
          </p>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <Link
              to="/contact"
              className="bg-white text-[#1B3A5F] px-10 py-4 rounded-full text-xl font-semibold hover:bg-gray-100 transition-all duration-300 whitespace-nowrap"
            >
              REQUEST A QUOTE
            </Link>
            <a
              href="tel:214-854-5638"
              className="border-2 border-white text-white px-10 py-4 rounded-full text-xl font-semibold hover:bg-white hover:text-[#1B3A5F] transition-all duration-300 flex items-center justify-center whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              (214) 854-5638
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Casper;
